/* eslint-disable */
import { Auth, API } from "aws-amplify";

const apiName = "AdminQueries";

async function getAuthHeader() {
  const session = await Auth.currentSession();
  return { Authorization: session.getIdToken().getJwtToken() };
}

export async function listUsers(limit, token) {
  const headers = await getAuthHeader();
  const queryStringParameters = {};
  if (limit) queryStringParameters.limit = limit;
  if (token) queryStringParameters.token = token;
  return API.get(apiName, "/listUsers", { headers, queryStringParameters });
}

export async function getUser(username) {
  const headers = await getAuthHeader();
  return API.get(apiName, "/getUser", {
    headers,
    queryStringParameters: { username },
  });
}

export async function createUser(username, email, givenName, familyName, agency, role) {
  const headers = await getAuthHeader();
  return API.post(apiName, "/createUser", {
    headers,
    body: { username, email, givenName, familyName, agency, role },
  });
}

export async function disableUser(username) {
  const headers = await getAuthHeader();
  return API.post(apiName, "/disableUser", {
    headers,
    body: { username },
  });
}

export async function enableUser(username) {
  const headers = await getAuthHeader();
  return API.post(apiName, "/enableUser", {
    headers,
    body: { username },
  });
}

export async function deleteUser(username) {
  const headers = await getAuthHeader();
  return API.post(apiName, "/deleteUser", {
    headers,
    body: { username },
  });
}
